export const CountryConst = {
    IDN: "IDN",
    DNMRK: "DNMRK",
    ITL: "Italy",
    KR: "KR",
    RSA: "RSA",
    CHI: "CHI",
    TW: "TW",
    AMR: "AMR",
    JP: "JP",
    FIN: "Finland",
    HUN: "Hungary",
    HK: "Hongkong",
    SR: "Singapore",
    TRK: "Turkey",
    EST: "Estonia",
    MYS: "Malaysia"
}

export const CountryAchiever = {
    IDN: "indonesia",
    DNMRK: "DNMRK",
    ITL: "Italy",
    KR: "KR",
    RSA: "RSA",
    CHI: "CHI",
    TW: "TW",
    AMR: "AMR",
    JP: "JP",
    FIN: "Finland",
    HUN: "Hungary",
    HK: "Hongkong",
    SR: "Singapore",
    TRK: "Turkey",
    EST: "Estonia"
}